module.exports = __webpack_public_path__ + "img/SKMJ_place6.41a5c1de.jpg";